import { Injectable } from '@angular/core';

import { NodeEntry } from '@alfresco/js-api';
import { from, Observable } from 'rxjs';

import { MsalService } from './msal.service';
import { WkAlfrescoApiService } from '../../services/wk-alfresco-api.service';
import { RequestParams } from '../../types';
import { MicrosoftSessionDetails } from '../types';

@Injectable({
  providedIn: 'root',
})
export class MsOnlineEditingService {
  private static readonly DEFAULT_NODE_PARAMS = {
    include: [
      'path',
      'properties',
      'allowableOperations',
      'permissions',
      'definition',
    ],
  };
  private static readonly MS_ONLINE_HEADER = 'X-Authorization-MS-Online';

  constructor(
    private readonly alfrescoApiService: WkAlfrescoApiService,
    private readonly msalService: MsalService
  ) {}

  public getNodeInfo(nodeId: string, nodeBody = {}): Promise<NodeEntry> {
    const queryParams = {
      ...MsOnlineEditingService.DEFAULT_NODE_PARAMS,
      ...nodeBody,
    };
    return this.alfrescoApiService.nodesApi.getNode(nodeId, queryParams);
  }

  public startEditingSession(
    nodeId: string,
    token: string
  ): Observable<MicrosoftSessionDetails> {
    const path = `${this.msalService.adapterUrl}${nodeId}`;
    const param = this.getRequestParam(path, token);
    return from(this.alfrescoApiService.callContentClientCustomApi(param));
  }

  public cancelEditingSession(
    nodeId: string,
    token: string
  ): Observable<MicrosoftSessionDetails> {
    const path = `${this.msalService.adapterUrl}${nodeId}/cancel`;
    const queryParams = { ignoreOpenEditors: 'true' };
    const param = this.getRequestParam(path, token, queryParams);
    return from(this.alfrescoApiService.callContentClientCustomApi(param));
  }

  public endEditingSession(
    nodeId: string,
    token: string,
    isMajor: boolean,
    comment = ''
  ): Observable<MicrosoftSessionDetails> {
    const path = `${this.msalService.adapterUrl}${nodeId}/end`;
    let queryParams: any = { isMajor, ignoreOpenEditors: 'true' };
    if (comment) {
      queryParams = { ...queryParams, comment };
    }
    const param = this.getRequestParam(path, token, queryParams);
    return from(this.alfrescoApiService.callContentClientCustomApi(param));
  }

  private getRequestParam(
    path: string,
    token: string,
    queryParams = null
  ): RequestParams {
    let param: RequestParams = {
      path,
      httpMethod: 'POST',
      contentTypes: ['application/json'],
      accepts: ['application/json'],
      headerParams: {
        [MsOnlineEditingService.MS_ONLINE_HEADER]: `Bearer ${token}`,
      },
    };
    if (queryParams) {
      param = { ...param, queryParams };
    }
    return param;
  }
}
